import React from 'react';
import { Navbar } from '../components/layout/Navbar';
import { Footer } from '../components/layout/Footer';
import { Hero } from '../components/sections/Hero';
import { About } from '../components/sections/About';
import { Services } from '../components/sections/Services';
import { Testimonials } from '../components/sections/Testimonials';
import { CTABanner } from '../components/sections/CTABanner';
import { Contact } from '../components/sections/Contact';
export function Home() {
  return <div className="min-h-screen bg-prt-darker font-sans text-white selection:bg-prt-blue selection:text-white" data-id="element-167">
      <Navbar data-id="element-168" />
      <main data-id="element-169">
        <Hero data-id="element-170" />
        <About data-id="element-171" />
        <Services data-id="element-172" />
        <Testimonials data-id="element-173" />
        <CTABanner data-id="element-174" />
        <Contact data-id="element-175" />
      </main>
      <Footer data-id="element-176" />
    </div>;
}